import React from "react";
import { LATAM_CANCELLLATION_LINK, GOL_CANCELLATION_LINK } from '../../../shared/constants';
import { Button } from "@maxmilhas/hangar-components-atomic/public";
import { css } from 'emotion';

const CancellationModal = props => {
	let state = {
		cia: false,
		links: false
	};

	const companyLinks = {
        latam: [
            {
				text: LATAM_CANCELLLATION_LINK,
				link: LATAM_CANCELLLATION_LINK
            }
        ],
        gol: [
            {
                text: GOL_CANCELLATION_LINK,
                link: GOL_CANCELLATION_LINK
            }
        ]
	};

	const closeButtonStyle = `
		border: 1px solid !important;
		margin-right: 15px;
		max-width: 110px;
		font-weight: 600 !important;
		color: #1abc9c !important;
		background-color: #fff !important;
		box-shadow: none !important;
	`

	const seeRequestButtonStyle = `
		border: 0;
		max-width: 192px;
		height: 48px;
		font-weight: 600 !important;
		box-shadow: none !important;

		&:disabled {
			background-color: #c8ccd4 !important;
		}
	`

	const wrapper = `
		position: fixed;
		top: 0;
		left: 0;
		display: flex;
		flex-direction: column;
		padding: 0 16px 36px;
		width: 100vw;
		height: 100vh;
		background-color: #fff;
		z-index: 99999;

		@media (min-width: 768px) {
			top: 50%;
			left: 50%;
			width: 100%;
			max-width: 530px;
			height: auto;
			max-height: 81vh;
			padding: 24px;
			border-radius: 8px;
			transform: translate(-50%, -50%);
		}
	`

	const mainTitleStyle = `
		font-size: 16px;
		font-weight: bold;
		color: #223254;

		@media (min-width: 768px) {
			font-size: 20px;
		}
	`

	const buttonWrapper = `
		display: flex;
		alignb-items: center;
		justify-content: center;
	`

	if (props.scenario) {
		switch (String(props.scenario.type).toLowerCase()) {
			case "eticketexpiredexception":
				return (
					<div className="tingle-modal-box cancellation-modal-box" data-section="my-trips-expired-flight">
						<div className="modal-header-wrapper">
							<p className="lead">Ah, que pena. Seu voo expirou!</p>
							<p>
								De acordo com as regras das companhias aéreas, o prazo para cancelamento de um voo é
								de até 360 dias a partir da data de emissão. Seu voo não está mais dentro deste
								prazo e, por isso, não pode mais ser cancelado.
								<br />
								<br />
								Em caso de dúvidas, confira as regras no site da companhia.
							</p>
						</div>
						<div className="tingle-modal-box__content">
							<div className="row">
								<div className="col-xs-16 col-md-16">
									<button
										id="btn_cancellation_modal"
										className="btn btn-success btn-go"
										onClick={() => props.closeModal()}
									>
										OK
									</button>
								</div>
							</div>
						</div>
					</div>
				);
				break;

			case "urgentexception":
				if (props.scenario.order) {
					const cia = props.scenario.order.flights.outbound.airline.toLowerCase();
					state = {
						cia: cia
					};
				}
				return (
					<div className="tingle-modal-box cancellation-modal-box" data-section={`my-trips-error-contact-us-${state.cia}`}>
						<div className="modal-header-wrapper">
							<p className="lead">Entre em contato por telefone!</p>
							<p>{props.scenario.message}</p>
							<p>
								Ligue para: <strong>(31) 3972.2101</strong>
							</p>
						</div>
						<div className="tingle-modal-box__content">
							<div className="row">
								<div className="col-xs-16 col-md-16">
									<button
										id="btn_cancellation_modal"
										className="btn btn-success btn-go"
										onClick={() => props.closeModal()}
									>
										OK
									</button>
								</div>
							</div>
						</div>
					</div>
				);
				break;

			case "noshowexception":
				if (props.scenario.order) {
					const cia = props.scenario.order.flights.outbound.airline.toLowerCase();
					state = {
						cia: cia,
						links: companyLinks[cia]
					};
				}
				return (
					<div className="tingle-modal-box cancellation-modal-box" data-section="my-trips-no-show">
							<div className="modal-header-wrapper">
									<p className="lead">Não é possível realizar o cancelamento :(</p>
									<p>{props.scenario.message}</p>
									<p><strong>Link para as regras da cia:</strong></p>
										{Array.isArray(state.links) && state.links.map(item => (
												<p>
														<a href={item.link} target="_blank" className="a-link">
																{item.text}
														</a>
												</p>
										))}
							</div>
							<div className="tingle-modal-box__content">
									<div className="row">
											<div className="col-xs-16 col-md-16">
													<button
															id="btn_cancellation_modal"
															className="btn btn-success btn-go"
															onClick={() => props.closeModal()}
													>
															OK
													</button>
											</div>
									</div>
							</div>
					</div>
                );
				break;

			case "orderstatechange":
			case "orderstatechangeexception":
				return (
					<div className="tingle-modal-box cancellation-modal-box" data-section="my-trips-order-change">
						<div className="modal-header-wrapper">
							<p className="lead">Ops!</p>
							<p>Houve uma mudança na situação do seu pedido. Por favor, tente novamente.</p>
						</div>
						<div className="tingle-modal-box__content">
							<div className="row">
								<div className="col-xs-16 col-md-16">
									<button
										className="btn btn-success btn-go"
										onClick={() => {
											window.location.pathname = "/cliente/minhas-viagens-light";
										}}
									>
										OK
									</button>
								</div>
							</div>
						</div>
					</div>
				);
				break;

			case "success":

				return (
					<div className="tingle-modal-box cancellation-modal-box">
						<div className="modal-header-wrapper">
							<p className="lead">Sua solicitação foi encaminhada!</p>
							<p>
								Recebemos seu pedido de cancelamento e em breve te enviaremos um retorno por e-mail.
							</p>
						</div>
						<div className="tingle-modal-box__content">
							<div className="row">
								<div className="col-xs-16 col-md-16">
									<button
										id="btn_cancellation_modal"
										className="btn btn-success btn-go"
										onClick={() => {
											window.location.pathname = "/cliente/minhas-viagens-light";
										}}
									>
										OK
									</button>
								</div>
							</div>
						</div>
					</div>
				);
				break;

				case "invalidchargebackvalueexception":

					return (
						<div className="tingle-modal-box cancellation-modal-box">
							<div className="modal-header-wrapper">
								<p className="lead">Não podemos prosseguir com a sua solicitação :(</p>
								<p>
									O valor total a ser pago para o cancelamento deste voo é maior do que o valor pago por você na compra da passagem. Por este motivo não é possível prosseguir com sua solicitação.
								</p>
							</div>
							<div className="tingle-modal-box__content">
								<div className="row">
									<div className="col-xs-16 col-md-16">
										<button
											id="btn_cancellation_modal"
											className="btn btn-success btn-go"
											onClick={() => props.closeModal()}
										>
											OK
										</button>
									</div>
								</div>
							</div>
						</div>
					);
					break;

			case 'existingcancellationrequestexception':
				let zendeskLink = '';
				if(props.scenario.ticketId){
					zendeskLink = 'https://ajuda.maxmilhas.com.br/hc/pt-br/requests/' + props.scenario.ticketId;
				} else {
					zendeskLink = 'https://ajuda.maxmilhas.com.br/hc/pt-br/requests?utf8=%E2%9C%93&query=' + props.scenario.transactionId + '&status='; 
				}
				return (
					<div data-section="my-trips-no-show" className={css`${wrapper}`}>
							<div className="modal-header-wrapper">
									<h3 className={css`${mainTitleStyle}`}>Solicitação em andamento</h3>
									<p>Você já solicitou a alteração dessa passagem e o seu pedido está em andamento. Se preferir, acompanhe os detalhes da sua solicitação.</p>
							</div>
							<div className={css`${buttonWrapper}`}>
								<Button className={css`${closeButtonStyle}`} onClick={() => props.closeModal()}>Voltar</Button>
								{!window.isWebview && <Button className={css`${seeRequestButtonStyle}`} onClick={() => window.open(zendeskLink)}>Ver solicitação</Button>}
							</div>
					</div>
                );
				break;

			default:
				return (
					<div className="tingle-modal-box cancellation-modal-box">
						<div className="modal-header-wrapper">
							<p className="lead">Ops! Alguma coisa deu errado.</p>
							<p>
								Não podemos prosseguir sua solicitação nesse momento, mas você pode entrar em
								contato com nosso time de atendimento 24h.
								<br />
								<br />
								Estamos à disposição para te atender :)
							</p>
						</div>
						<div className="tingle-modal-box__content">
							<div className="row">
								<div className="col-xs-16 col-md-16">
									<button
										id="btn_cancellation_modal"
										className="btn btn-success btn-go"
										onClick={() => props.closeModal()}
									>
										OK
									</button>
								</div>
							</div>
						</div>
					</div>
				);
				break;
		}
	}

	return null;
};

export default CancellationModal;
